export const PreferencesEnum = {
  None: 0,
  ChangeStudentStatus: 130,
  ChangeStudentBalance: 131,
  UpdateChargePermissions: 133,
  WithdrawStudent: 134,
  AddNewSite: 135,
  DeleteStudent: 136,
  ModifyProhibitedItems: 137,
  AssignAllergens: 138,
  ModifyNotes: 139,
  ChangeStudentNumber: 140,
  AssignUsers: 141,
  DeleteSite: 142,
  AllowPastEffectiveDate: 144,
  CanChangeServingDate: 150,
  MBEEmailLetters: 153,
  AssignServedItemsToSite: 156,
  ModifyMealSummary: 157,
  OrderDeliveryDate: 158,
  AllowEmailLetters: 159,
  AllowEmailNotificationDC: 161,
  AutoImportSettings: 122,
  ReceiptPrice: 301,
  EnableCreditCard: 163,
  PhysicalLoadOnHand: 309,
  AllowOverrideChargeLimits: 166,
  WarehouseHold: 323,
  WarehouseAvailability: 324,
  WarehouseLoad: 325,
  AssignUsersReadOnlyAccess: 0,
  PhysicalReportIncludeCurrentOnHand: 333,
  ServeVisitingStudentsViaPinPad: 340,
  AllowSecondReview: 341,
  AllowAccessToVerification: 342,
  TruckRouteSetup: 344,
  TruckRouteSchedule: 345,
  AutopopulateDeposit: 348,
  ProcessOrders: 352,
  ClosePhysicals: 353,
  ReopenProductRecord: 374,
};



// WEBPACK FOOTER //
// ./src/common/Security/PreferencesEnum.js